/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

/* eslint-disable no-multi-spaces */

/**
 * Defines the BMW Portal Application keys which are to be used for all iOn specific
 * constant references, such as when initializing User Preferences, getting / setting
 * localStorage values, etc.
 */
export enum ApplicationKeys {
  BMWPortal            = 'ion-bmw-portal',
  BMWPortalSession     = 'ion-bmw-portal-session',
  BMWPortalSessionTime = 'ion-bmw-portal-session-time',
  BMWPortalPage        = 'ion-bmw-portal-page'
};

/**
 * Defines the BMW Portal Application language keys which are to be used for fetching
 * translation files.
 */
export enum Language {
  'de_DE' = 'de',
  'en_GB' = 'en',
  'es_ES' = 'es',
  'fr_FR' = 'fr',
  'it_IT' = 'it',
  'nl_NL' = 'nl'
};
